var stateManager = require('../../state/stateManager.js');
var storefrontUtility = require('../../domain/storefrontUtility.js');
var effectiveMenuCalculator = require('./effectiveMenuCalculator.js');
var constants = require('../../domain/constants.js');
var logger = require('../../logger/logger.js');

module.exports.getAllMenus = function()
{
    return stateManager.getStore().getState().menus;
}

module.exports.getPrimaryMenu = function(propertyId, storefrontId, venueCode, dispatchType)
{
    return getMenu(propertyId, storefrontId, venueCode, dispatchType, constants.menuType.Primary);
}

function getMenu(propertyId, storefrontId, venueCode, dispatchType, menuType)
{
    var allMenus = module.exports.getAllMenus();

    var menu = null;
    var applicableMenuAndPriceBand = getApplicableMenuAndPriceBand(storefrontId, menuType);
    if (applicableMenuAndPriceBand != null)
    {
        menu = allMenus.find(m => m.id == applicableMenuAndPriceBand.menuId);
    }  

    if (menu == null)
    {
        logger.warn(`Failed to find default ${menuType} menu for storefront id: ${storefrontId}`)
        return null;
    }  

    var effectiveMenu = effectiveMenuCalculator.calculateEffectiveMenu(applicableMenuAndPriceBand.priceBandId, menu, propertyId, venueCode, dispatchType);
    if (effectiveMenu == null)
    {
        if (menuType == constants.menuType.Primary)
            logger.warn(`Failed to find effective ${menuType} menu for storefront id: ${storefrontId}, venueCode: ${venueCode}, dispatchType: ${dispatchType}`)
        return null;
    }

    return effectiveMenu;
}


function getApplicableMenuAndPriceBand(storefrontId, menuType)
{
    var storefront = storefrontUtility.getStorefrontById(storefrontId);

    if (storefront == null)
        return null;

    if (menuType == constants.menuType.Primary)
    {
        return {
                    menuId: storefront.menuId,
                    priceBandId: storefront.priceBandId
        };
    }
}